import { ApiGeometry, Line, Point, PointColors, Polygon } from '../models/Geometries';

export class ApiGeometryUtils {
  static toUserDrawnPolygon(apiGeometry: ApiGeometry): Polygon {
    return {
      puntos: (apiGeometry.geometria.coordinates as number[][][]).flat(1).map(coords => ({
        latitud: coords[1],
        longitud: coords[0],
      })),
      adjuntos: apiGeometry?.adjuntos,
      fechaCreacion: new Date(apiGeometry.createdAt).getTime(),
      tipo: 'poligono',
      titulo: apiGeometry.titulo,
      descripcion: apiGeometry.descripcion ?? '',
      perimetro: apiGeometry?.atributos?.perimetro ?? '',
      area: apiGeometry.atributos?.area ?? '',
      id: apiGeometry.id,
      usuario: apiGeometry.usuario,
      createdBy: apiGeometry.usuario?.nombre + ' ' + apiGeometry.usuario?.apellido,
      color: apiGeometry.atributos?.style?.color ?? PointColors[0],
    };
  }

  static toUserDrawnLine(apiGeometry: ApiGeometry): Line {
    return {
      puntos: (apiGeometry.geometria.coordinates as number[][]).map(coords => ({
        latitud: coords[1],
        longitud: coords[0],
      })),
      fechaCreacion: new Date(apiGeometry.createdAt).getTime(),
      tipo: 'linea',
      adjuntos: apiGeometry?.adjuntos,
      titulo: apiGeometry.titulo,
      usuario: apiGeometry.usuario,
      descripcion: apiGeometry.descripcion ?? '',
      distancia: apiGeometry.atributos?.distancia ?? '',
      id: apiGeometry.id,
      createdBy: apiGeometry.usuario?.nombre + ' ' + apiGeometry.usuario?.apellido,
      color: apiGeometry.atributos?.style?.color ?? PointColors[0],
    };
  }

  static toUserDrawnPoint(apiGeometry: ApiGeometry): Point {
    return {
      longitud: apiGeometry.geometria.coordinates[0],
      latitud: apiGeometry.geometria.coordinates[1],
      atributos: apiGeometry?.atributos,
      fechaCreacion: new Date(apiGeometry.createdAt).getTime(),
      tipo: 'punto',
      titulo: apiGeometry.titulo,
      usuario: apiGeometry.usuario,
      adjuntos: apiGeometry?.adjuntos,
      descripcion: apiGeometry.descripcion ?? '',
      categoria: apiGeometry?.categoria,
      numeroActa: apiGeometry?.numeroActa ?? '',
      numExp: apiGeometry.numExp ?? '',
      id: apiGeometry.id,
      createdBy: apiGeometry.usuario?.nombre + ' ' + apiGeometry.usuario?.apellido,
      color: apiGeometry.atributos?.style?.color ?? PointColors[0],
    };
  }
}

export const getNumberOfPhotos = (geometries: ApiGeometry[]): number => {
  return geometries.map(p => p.adjuntos?.length ?? 0).reduce((p, c) => p + c, 0);
}
